<template>
  <div class="subscribe-detail">
    <van-image width="100%" :src="goodImage">
      <!-- 图标加载失败 -->
      <template #error>
        <van-icon name="photo-o" />
      </template>
    </van-image>
    <!-- 商品信息列表 -->
    <van-cell-group class="goods-info">
      <van-cell title="商品名称">
        <template>
          <span v-html="goodsInfo.name"></span>
        </template>
      </van-cell>
      <van-cell title="商品价格">
        <template #default>
          <span v-html="goodsInfo.price"></span>
        </template>
      </van-cell>
      <van-cell title="数量" v-if="typeId !== 4">
        <template #title>数<span style="margin-left: 1.7rem">量</span></template>
        <template #default>
          <van-stepper v-model="goodsInfo.count" :disabled="typeId === 1" theme="round" button-size="22" disable-input />
        </template>
      </van-cell>
      <van-cell title="商品说明" value="">
        <template #default>
          <span v-html="goodsInfo.explain"></span>
        </template>
      </van-cell>
    </van-cell-group>
    <!-- 非零售 -->
    <van-cell-group v-if="typeId === 4">
      <van-cell title="订阅" is-link value="选择日期及数量" @click="chooseDate" />
    </van-cell-group>
    <!-- 日期列表操作 零售 -->
    <template v-if="typeId === 4 && $store.state.newsKiosk.dateList.length">
      <van-swipe-cell v-for="(item, index) in $store.state.newsKiosk.dateList" :key="index" class="list-date">
        <van-cell :border="false" :title="item.date" value="">
          <template #title> {{ item.date }} <span v-if="item.verify" style="font-size: 12px">库存不足，请修改</span> </template>
          <template>
            <van-stepper v-model="item.number" integer :min="$store.state.newsKiosk.dateList.length < 2 ? 1 : 0" @change="changeNumber(item)" />
          </template>
        </van-cell>
        <template #right>
          <van-button square type="danger" text="移出" @click="deleDate(item)" />
        </template>
      </van-swipe-cell>
    </template>
    <!-- 立即订阅按钮 -->
    <van-button type="primary" block @click="checkUserSubscribe">立即订阅</van-button>
    <!-- 日期选择组件 -->
    <van-calendar
      v-model="calendarShow"
      type="multiple"
      :min-date="minStock"
      :max-date="maxStock"
      title="报纸单价及库存"
      :close-on-click-overlay="false"
      @confirm="chooseConfirmDate"
      :formatter="calendarFormat"
      :lazy-render="false"
      :default-date="calendarDafaultDate"
      ref="calendar"
    >
      <template #top-info="day">
        <template v-if="getStockInfo(day.date) && getStockInfo(day.date).holidayType">
          <p>休</p>
        </template>
      </template>
      <template #bottom-info="day">
        <template
          v-if="
            !day.type ||
            day.type === 'selected' ||
            day.type === 'middle' ||
            day.type === 'start' ||
            day.type === 'end' ||
            day.type === 'start-end' ||
            day.type === 'multiple-selected' ||
            day.type === 'multiple-middle'
          "
        >
          <template v-if="getStockInfo(day.date)">
            <p>{{ '￥' + getStockInfo(day.date).price }}</p>
            <template v-if="getStockInfo(day.date).stockNum">
              <p>余{{ getStockInfo(day.date).stockNum }}份</p>
              <p v-if="greaterThanToday(day.date)" class="empty">预售</p>
            </template>
            <p v-else class="empty">售罄</p>
          </template>
          <!-- <p>{{ stockInfo[moment(day.date).format('YYYY-MM-DD')] }}</p> -->
        </template>
      </template>
      <!-- <template #footer>
        <van-button type="primary" @click="closeCalendar" round>确定</van-button>
      </template> -->
    </van-calendar>
  </div>
</template>

<script>
  // 混入文件
  import { subscribeDetail } from '@/mixins/newsKiosk/subscribeDetail'
  import moment from 'moment'
  export default {
    mixins: [subscribeDetail],
    data() {
      return {
        dateList: [],
        calendarShow: false,
        goodImage: '',
        typeId: 1, // 销售类型，4为零售
        goodsId: 0, // 商品id
        price: 0,
        stockInfo: [], // 日历对应信息
        minStock: new Date(), // 最小范围 当月
        maxStock: new Date(), // 最大范围 当月
        calendarDafaultDate: [moment().toDate()] // 打开弹窗回显
      }
    },
    mounted() {
      let { id } = this.$route.query
      this.detail(id)
    }
  }
</script>

<style lang="scss" scoped>
  .subscribe-detail {
    /deep/ a {
      color: #ff5757;
    }
    /deep/ .van-image {
      background-color: #fff;
      text-align: center;
      height: 50vh;
      display: flex;
      align-items: center;
      justify-content: center;
      .van-image__error,
      .van-image__img,
      .van-image__loading {
        position: relative;
        display: inline-block;
        width: auto;
        height: 90%;
        font-size: 3rem;
        background-color: transparent;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .van-cell-group,
    .van-button {
      margin: 10px auto 0;
    }

    .van-button {
      width: 90%;
      margin-bottom: 10px;
    }

    .empty {
      color: #ff5757;
    }

    .van-cell__title,
    .van-cell__value {
      color: #000;
    }

    // 订阅
    .list-date {
      /deep/ .van-cell__title {
        flex: 2;
        span {
          color: #ff5757;
        }
      }
      .van-swipe-cell__right {
        .van-button {
          margin: 0;
          width: 100%;
          height: 100%;
        }
      }
    }

    // 重写cell布局 需求
    .goods-info {
      .van-cell__title {
        min-width: 80px;
        flex: inherit;
      }
      .van-cell__value {
        text-align: left;
        flex: 1.5;
      }
    }

    // 重写日历
    /deep/ .van-calendar__day {
      height: 84px;
      align-items: flex-start;
      line-height: 2.5;
      &.holiday:not(.van-calendar__day--end):not(.van-calendar__day--start):not(.van-calendar__day--start-end):not(.van-calendar__day--multiple-selected) {
        color: #ff5757;
      }
      .van-calendar__selected-day {
        height: 84px;
        align-items: flex-start;
      }
      .van-calendar__top-info {
        top: 0px;
        right: -35px;
        color: #07c160;
      }
      .van-calendar__bottom-info {
        bottom: -10px;
        height: 60px;
        p {
          font-weight: 500;
          color: #777;
          margin: 0;
          line-height: 1.4;
          &.empty {
            color: #ff5757;
          }
        }
      }
    }
    /deep/ .van-calendar__day--start,
    /deep/ .van-calendar__selected-day,
    /deep/ .van-calendar__day--multiple-selected,
    /deep/ .van-calendar__day--end {
      background-color: #ff5757 !important;
      border-radius: 0;
      p {
        color: #fff !important;
      }
    }
    /deep/ .van-calendar__day--start-end {
      background-color: #ff5757;
      .van-calendar__bottom-infom,
      .van-calendar__top-info {
        color: #fff !important;
      }
      p {
        color: #fff !important;
      }
    }
    /deep/ .van-calendar__day--middle,
    /deep/ .van-calendar__day--multiple-middle {
      background-color: #ff5757;
      border: 0;
      color: #fff !important;
      &::after {
        background-color: #ff5757;
      }
      .van-calendar__top-info {
        color: #fff;
      }
      .van-calendar__bottom-info {
        p {
          color: #fff;
          &.empty {
            color: #ff5757;
          }
        }
      }
      .empty {
        color: #ff5757 !important;
      }
    }
    /deep/ .van-calendar__day--multiple-middle {
      .empty {
        color: #fff !important;
      }
    }
    /deep/ .van-calendar__footer {
      text-align: center;
    }
  }
</style>
